// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import postApprovalEntity from './entities/post-approval.json';
import postApprovalMenu from '../pages/post-approval/menu.json';
import postApprovalFullForm from '../pages/post-approval/forms/full.json';
import postApprovalContextForm from '../pages/post-approval/forms/context.json';
import postApprovalMiniForm from '../pages/post-approval/forms/mini.json';
import postApprovalLookupForm from '../pages/post-approval/forms/lookup.json';
import postApprovalTableView from '../pages/post-approval/views/table.json';
import postApprovalCardsView from '../pages/post-approval/views/cards.json';
import postApprovalCalendarView from '../pages/post-approval/views/calendar.json';
import postApprovalDashboardView from '../pages/post-approval/views/dashboard.json';

/** Тип запису «Погодження допису» зі сторінками пакета: меню, форми та подання з pages/post-approval/. */
export const postApprovalDefinition: IRecordTypeDefinition = {
  ...postApprovalEntity,
  views: assembleViewSet({
      table: postApprovalTableView,
      cards: postApprovalCardsView,
      calendar: postApprovalCalendarView,
      dashboard: postApprovalDashboardView,
  }),
  form: postApprovalFullForm,
  forms: { full: postApprovalFullForm, context: postApprovalContextForm, mini: postApprovalMiniForm, lookup: postApprovalLookupForm },
  menu: postApprovalMenu,
} as IRecordTypeDefinition;
